module.exports = __webpack_public_path__ + "img/文本图 视频_1 副本 7.63e6556e.jpg";